import React from "react";
import { createRoot } from "react-dom/client";
import { ConfigProvider } from "antd";
import deDE from "antd/lib/locale/de_DE";

import "antd/dist/reset.css";
import "./index.css";
import App from "./components/App/App";


const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ConfigProvider locale={deDE}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
